module.exports = __webpack_public_path__ + "static/media/sv.87a8f583.svg";